import React from "react";
import Map from "Components/Map/Map";
import CartoLayer from "Components/Map/CartoLayer";
import Interaction from "Components/Map/Interaction";
import Tooltip from "Components/Map/Tooltip";

import { maxBounds } from "Lookups";
import { state } from "State";
import databaseCache from "Services/databaseCache";

import onlyUpdateForKeys from "recompose/onlyUpdateForKeys";
import lifecycle from "recompose/lifecycle";
import config from "Config";

const tooltipTemplate = (
  interactivity,
  { community, community_value }
) => data => {
  let title = interactivity.length > 1 ? data[interactivity[0]] : config.admin_state_name;

  let value = data[interactivity[interactivity.length - 1]];

  return `<div style="border: solid 0.2px black;" class="white p-2">
    <strong>${title}</strong>
    <p>
      Population${
        community && community_value
          ? ` (${community}: ${community_value})`
          : ""
      }: ${value.toLocaleString()}
    </p>
  </div>`;
};
/**
 * @param  {} {data}
 */
const setStatefromFeatureClick = interactivity => ({ data, ...rest }) =>
  // HACK: FIXME: for some reason fields and content keys are being added to onFeatureClick's data when State is showing
  delete data.fields &&
  delete data.content &&
  interactivity.length > 1 &&
  Object.keys(data).filter(x => x !== "number").length > 0 &&
  data[Object.keys(data).filter(x => x !== "number")[0]].chain(
    name =>
      name && state.select(["domain_data", "geo_aggregation_value"]).set(name)
  );

const outlineCartoCss = "#layer { line-width: 2; line-color: #555;}";
const guardUpdates = onlyUpdateForKeys([
  "sql",
  "cartocss",
  "interactivity",
  "boundaries",
  "domain_data",
  "visible"
]);

const Template = ({
  sql,
  cartocss,
  interactivity,
  boundaries,
  domain_data,
  visible
}) => (
  <Map key="map" {...{ boundaries, maxBounds, visible }}>
    {/* The Main Map Layer */}
    <CartoLayer {...{ sql, cartocss }} key={"cohropleth"}>
      <Interaction
        interactivity={interactivity}
        click={setStatefromFeatureClick(interactivity)}
      />
      <Tooltip
        interactivity={interactivity}
        template={tooltipTemplate(interactivity, domain_data)}
      />
    </CartoLayer>

    {/* FIXME: Tooltip doesn't work if a 2nd layer is included when the map is first loaded. Tooltip Component receives the 2nd (Wrong) layer from the CartoLayer component
      <CartoLayer
      key={domain_data.geo_aggregation_value}
      sql={databaseCache.getQuery("POLYGON_QUERY", domain_data)}
      cartocss={outlineCartoCss}
    ></CartoLayer> */}
  </Map>
);

export default guardUpdates(Template);



// WEBPACK FOOTER //
// ./components/MapComponent.js